package com.iregained.site.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import com.iregained.site.components.cms.CmsSection
import com.iregained.site.components.cms.DynamicSectionRenderer
import com.iregained.site.components.layouts.PageLayout
import com.iregained.site.components.widgets.BackToTopButton
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.core.Page
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.events.EventListener

@Page("/news")
@Composable
fun NewsPage() {
    val pageSections: List<CmsSection> = listOf(
        CmsSection.NewsFeaturedSection(),
        CmsSection.NewsGridSection(),
        CmsSection.NewsPressKitSection(),
    )

    // 1. Restore the scroll position when the page fully loads and expands
    LaunchedEffect(Unit) {
        val savedScroll = window.sessionStorage.getItem("news_scroll_position")?.toDoubleOrNull()

        if (savedScroll != null && savedScroll > 0) {
            var checkCount = 0
            val intervalId = window.setInterval({
                val currentHeight = document.body?.scrollHeight ?: 0
                checkCount++
                if (currentHeight > savedScroll || checkCount > 10) {
                    window.scrollTo(0.0, savedScroll)
                }
            }, 100)
            window.setTimeout({ window.clearInterval(intervalId) }, 1500)
        }
    }

    // 2. Continuously track and save the scroll position to sessionStorage
    DisposableEffect(Unit) {
        val scrollListener = EventListener {
            window.sessionStorage.setItem("news_scroll_position", window.scrollY.toString())
        }
        window.addEventListener("scroll", scrollListener)
        onDispose { window.removeEventListener("scroll", scrollListener) }
    }

    PageLayout {
        Column(
            modifier = Modifier.fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally
        ) {
            // DYNAMIC RENDERER LOOP
            pageSections.forEach { section ->
                DynamicSectionRenderer(section)
            }
        }
        BackToTopButton()
    }
}